import { Box } from '@chakra-ui/react'
import { Product } from 'BrokerTsLib/src/enums'
import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { BaseHeader } from '../components/BaseHeader'
import { Footer } from '../components/Footer'
import { Loading } from '../components/Loading'
import { WithAuth } from '../containers/hoc/WithAuth'
import { AppProvider } from '../context/AppContext'
import { useAuth } from '../context/AuthContext'

export const _AppSelectorLayout = () => {
  const { user } = useAuth() ?? {}
  const navigate = useNavigate()

  const [showSelector, setShowSelector] = useState(false)

  useEffect(() => {
    if (!user) return

    const arr = []

    if (user.vehicleRights) arr.push(Product.VehicleInsurance)
    if (user.propertyRights) arr.push(Product.PropertyInsurance)
    if (user.travelRights) arr.push(Product.TravelInsurance)

    setShowSelector(arr.length > 1)
    const directNavigation = arr.length == 1

    if (directNavigation && user.vehicleRights) navigate('/carkulka')
    else if (directNavigation && user.travelRights) navigate('/cestovko')
    else if (directNavigation && user.propertyRights) {
      navigate(`/chaloupka`)
    }

    if (arr.length == 0) {
      navigate('/unauthorized')
    }
  }, [user])

  return (
    <>
      {!showSelector && <Loading large={true} />}
      {showSelector && (
        <AppProvider app={null}>
          <Box sx={{ minH: '100vh', display: 'grid', alignItems: 'start' }}>
            <BaseHeader />

            <Outlet />

            <Footer sx={{ alignSelf: 'end' }} hideLinks />
          </Box>
        </AppProvider>
      )}
    </>
  )
}

export const AppSelectorLayout = WithAuth(_AppSelectorLayout)
